/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import2 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import3 from '../../orchestration/page';
import * as import4 from '../../orchestration/navigation.service';
import * as import5 from './adyen-3ds-page.component';
import * as import6 from '../../orchestration/navigation-params';
import * as import7 from '../payment.model';
const styles_Adyen3dsPageComponent:any[] = ([] as any[]);
export const RenderType_Adyen3dsPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_Adyen3dsPageComponent,
  data: {}
}
);
export function View_Adyen3dsPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    import0.ɵqud(402653184,2,{threeDsHolder: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import1.View_ModalPageLayoutComponent_0,import1.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import2.ModalPageLayoutComponent,[
      import3.Page,
      import4.NavigationService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      customGeometry: [
        1,
        'customGeometry'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,3,{contentMessages: 1}),
    import0.ɵqud(603979776,4,{footerControls: 1}),
    import0.ɵpod([
      'disableSwipe',
      'height'
    ]
    ),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import3.PageLayout,(null as any),[import2.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵeld(0,[
      [
        2,
        0
      ]
      ,
      [
        'threeDsHolder',
        1
      ]

    ]
      ,4,0,'div',[[
        'class',
        'threeDs-holder'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.heading.3ds.title';
    const currVal_1:any = ck(v,6,0,true,'100%');
    ck(v,3,0,currVal_0,currVal_1);
  },(null as any));
}
function View_Adyen3dsPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-adyen-3ds-page',([] as any[]),(null as any),(null as any),(null as any),View_Adyen3dsPageComponent_0,RenderType_Adyen3dsPageComponent)),
    import0.ɵdid(4898816,(null as any),0,import5.Adyen3dsPageComponent,[
      import6.NavigationParams,
      import4.NavigationService,
      import7.PaymentModel
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import3.Page,(null as any),[import5.Adyen3dsPageComponent])
  ]
  ,(null as any),(null as any));
}
export const Adyen3dsPageComponentNgFactory:import0.ComponentFactory<import5.Adyen3dsPageComponent> = import0.ɵccf('woa-adyen-3ds-page',import5.Adyen3dsPageComponent,View_Adyen3dsPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvcGF5bWVudC9hZHllbi0zZHMtcGFnZS9hZHllbi0zZHMtcGFnZS5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9wYXltZW50L2FkeWVuLTNkcy1wYWdlL2FkeWVuLTNkcy1wYWdlLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvcGF5bWVudC9hZHllbi0zZHMtcGFnZS9hZHllbi0zZHMtcGFnZS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvcGF5bWVudC9hZHllbi0zZHMtcGFnZS9hZHllbi0zZHMtcGFnZS5jb21wb25lbnQudHMuQWR5ZW4zZHNQYWdlQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHdvYS1tb2RhbC1wYWdlLWxheW91dCBbdGl0bGVdPVwiJ3dvYS5oZWFkaW5nLjNkcy50aXRsZSdcIiBbY3VzdG9tR2VvbWV0cnldPVwie2Rpc2FibGVTd2lwZTogdHJ1ZSwgaGVpZ2h0OiAnMTAwJSd9XCI+XG4gICAgPGRpdiAjdGhyZWVEc0hvbGRlciBjbGFzcz1cInRocmVlRHMtaG9sZGVyXCI+PC9kaXY+XG48L3dvYS1tb2RhbC1wYWdlLWxheW91dD5cbiIsIjx3b2EtYWR5ZW4tM2RzLXBhZ2U+PC93b2EtYWR5ZW4tM2RzLXBhZ2U+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lDQUE7Z0JBQUE7OztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBO2dCQUFBO2dCQUF5RDtNQUFBO01BQUE7SUFBQTtJQUFBO2tCQUF6RDtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQWlIO0lBQzdHO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQWlEO0lBQzdCOzs7SUFGRDtJQUFrQztJQUF6RCxTQUF1QixVQUFrQyxTQUF6RDs7Ozs7SUNBQTtnQkFBQTs7OztJQUFBO0tBQUE7Z0JBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/app/payment/adyen-3ds-page/adyen-3ds-page.component.ngfactory.ts